import { wealthProApi } from "../../redux/api";

const verifyApiEndpoints = wealthProApi.enhanceEndpoints({
    addTagTypes: ['factFindVerification']
}).injectEndpoints({
    endpoints: (builder) => ({
        fetchFactFindVerificationStatus: builder.query({
            query: ({ masterAccountId }) => `api/factfind/verify/${masterAccountId}`,
            providesTags: (_r, err, { masterAccountId }) => err ? [] : [{ type: 'factFindVerification', id: masterAccountId }]
        }),
        verifyFactFind: builder.mutation({
            query: ({ masterAccountId, ...body }) => ({
                url: `api/factfind/verify/${masterAccountId}`,
                method: "POST",
                body
            }),
            invalidatesTags: (_r, err, { masterAccountId }) => err ? [] : [{ type: 'factFindVerification', id: masterAccountId }]
        })
    })
})

export const {
    useFetchFactFindVerificationStatusQuery,
    useVerifyFactFindMutation
} = verifyApiEndpoints;